import React, { useState } from 'react';

import { submit } from '../../../AppServices';
import { Form } from '../../../app-components/form/FormNoti';
import { autoSuggestOptionsInput } from '../../../autoSuggestions';
import { MODELS, ROUTES, selectEmployeeStatus, selectStatus } from '../../../Lib/constants';
import { getUserRole, validateEmail } from '../../../Lib/helpers';
import { EditAppraiseEmployeeURI } from '../../../Queries/appraiseEmployee';
import { getUser, invoke } from '../../../AppServices';
import Toast from '@applane/react-toast';

const validations = {
  email: ({ data }) => validateEmail(data?.email),
};

const UserCheckBox = ({props}) => {
  const employeeData = getUser()
  console.log('employeeData', employeeData)
  console.log('props', props)
  const data = props?.navigation?.state?.params?.item
  console.log("Employee data", data)
  const [isChecked, setIsChecked] = useState(data?.dealerReceiveOffers ? true : false );
  console.log('isChecked', isChecked)

  const handleCheckboxChange = (event) => {
    if (isChecked) {
      setIsChecked(false);
    } else if (!isChecked) {
      setIsChecked(true);
    }
    console.log(isChecked)
    dealerReceiveOffersEmail()
  };

  const dealerReceiveOffersEmail = async () => {
    try {
      const updateSettings = await invoke({
        id: 'dealerReceiveOffersEmail',
        paramValue: {
          data: {
            employeeId: data._id,
            dealerReceiveOffers: isChecked ? false : true
          }
        },
      });

      Toast.show({
        message: 'Success',
        description: updateSettings.message,
        type: 'success',
        position: 'top',
        direction: 'left',
        duration: 5000,
      });

      // Additional logic if needed after successful deletion
    } catch (error) {
      // Handle errors if the deletion fails
      console.error('Error deleting inactive dealer:', error);
    }
  };



  return (
    <div>
      <hr />

      <p style={{ fontSize: '1.5rem', marginBottom: '20px' }}>If you want to receive the offers email that we have sent to the customer, click on the button below.</p>

      <div>
        <label class="switch">
          <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  )
}









const UserWeekReport = ({props}) => {
  const data = props?.navigation?.state?.params?.item
  // console.log('dealerData?.dealer?.dealerReceiveOffersEmail', dealerData?.dealer)
  const [isChecked, setIsChecked] = useState(data?.dealerWeeklyReport === 'Yes' ? true : false);

  // console.log('isCheckedUserWeekReport', isChecked)

  const handleCheckboxChange = (event) => {
    if (isChecked) {
      setIsChecked(false);
    } else if (!isChecked) {
      setIsChecked(true);
    }
    console.log('isCheckedUserWeekReport', isChecked)
    dealerReceiveWeeklyReport()
  };

  const dealerReceiveWeeklyReport = async () => {
    try {
      const updateSettings = await invoke({
        id: 'dealerReceiveWeeklyReport',
        paramValue: {
          data: {
            employeeId: data._id,
            dealerWeeklyReport: isChecked ? 'No' : 'Yes'
          }
        },
      });

      Toast.show({
        message: 'Success',
        description: updateSettings.message,
        type: 'success',
        position: 'top',
        direction: 'left',
        duration: 5000,
      });

      // Additional logic if needed after successful deletion
    } catch (error) {
      // Handle errors if the deletion fails
      console.error('Error deleting inactive dealer:', error);
    }
  };



  return (
    <div>
      <hr />

      <p style={{ fontSize: '1.5rem', marginBottom: '20px' }}>
        If you wish to receive the weekly report for your account, including details such as Appraisals Captured, Generated, and Failed, click on the button below.</p>

      <div>
        <label class="switch">
          <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  )
}

const UserModalWeeklyReport = ({props}) => {
  const data = props?.navigation?.state?.params?.item
  const [isChecked, setIsChecked] = useState(data?.dealerModalWeeklyReport === 'Yes' ? true : false);


  const handleCheckboxChange = (event) => {
    if (isChecked) {
      setIsChecked(false);
    } else if (!isChecked) {
      setIsChecked(true);
    }
    console.log('isCheckedUserWeekReport', isChecked)
    dealerModalWeeklyReport()
  };

  const dealerModalWeeklyReport = async () => {
    try {
      const updateSettings = await invoke({
        id: 'dealerReceiveModalWiseWeekly',
        paramValue: {
          data: {
            employeeId: data._id,
            dealerModalWeeklyReport: isChecked ? 'No' : 'Yes'
          }
        },
      });

      Toast.show({
        message: 'Success',
        description: updateSettings.message,
        type: 'success',
        position: 'top',
        direction: 'left',
        duration: 5000,
      });

      // Additional logic if needed after successful deletion
    } catch (error) {
      // Handle errors if the deletion fails
      console.error('Error deleting inactive dealer:', error);
    }
  };



  return (
    <div>
      <hr />

      <p style={{ fontSize: '1.5rem', marginBottom: '20px' }}>
        If you would like to receive the weekly report of appraisals generated, categorized by models, click on the button below.</p>

      <div>
        <label class="switch">
          <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange}/>
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  )
}


const CustomerInterestNoti = ({props}) => {
  const data = props?.navigation?.state?.params?.item
  const [isChecked, setIsChecked] = useState(data?.customerInterestNoti === 'Yes' ? true : false);


  const handleCheckboxChange = (event) => {
    if (isChecked) {
      setIsChecked(false);
    } else if (!isChecked) {
      setIsChecked(true);
    }
    console.log('isCheckedUserWeekReport', isChecked)
    dealerModalWeeklyReport()
  };

  const dealerModalWeeklyReport = async () => {
    try {
      const updateSettings = await invoke({
        id: 'customerInterestNotification',
        paramValue: {
          data: {
            employeeId: data._id,
            customerInterestNoti: isChecked ? 'No' : 'Yes'
          }
        },
      });

      Toast.show({
        message: 'Success',
        description: updateSettings.message,
        type: 'success',
        position: 'top',
        direction: 'left',
        duration: 5000,
      });

      // Additional logic if needed after successful deletion
    } catch (error) {
      // Handle errors if the deletion fails
      console.error('Error deleting inactive dealer:', error);
    }
  };



  return (
    <div>
      <hr />

      <p style={{ fontSize: '1.5rem', marginBottom: '20px' }}>
        If you would like to receive notifications when a customer shows interest in an appraisal offer, click on the button below.
      </p>
      <div>
        <label class="switch">
          <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  )
}



const deleteEmployee = async (employeeId) => {


  let deleteUser = await invoke({
    id: 'deleteEmployee',
    paramValue: {
      employeeId,
    },
  });

  Toast.show({
    message: 'Success',
    description: deleteUser.message,
    type: 'success',
    position: 'top',
    direction: 'left',
    duration: 3000,
  });

  window.location.reload()
}



const Modal = ({ props }) => {
  const employeeName = props?.navigation?.state?.params?.item?.username;
  const data = props?.navigation?.state?.params?.item

  return (
    <div class="modal fade" id="basicModal" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          {/* <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div> */}
          <div class="modal-body">
            <h4>Are you sure you want to delete this employee. <br /> Employee Name : {employeeName}?</h4>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-danger" data-dismiss="modal" onClick={()=>deleteEmployee(data._id)}>Yes</button>
          </div>
        </div>
      </div>
    </div>
  )
}




const EditAppraiseEmployee = (props) => (
  <>
  <Modal props={props} />
  <Form
    type="standard"
    uri={EditAppraiseEmployeeURI}
    closeView={1}
    reloadEvent={ROUTES.employeeData.name}
    reloadOnChangeEvent={ROUTES.employeeData.name}
    onSubmit={submit({
      model: MODELS.APPRAISE_EMPLOYEE,
    })}
    validations={validations}
    mandatory={{ username: 1 }}
    submitMessage="Employee Updated Successfully"
    uniqueValidationMessage="Username already exists."
    fieldContainer="topLabel"
    lg={{
      formGroups: [
        {
          columnsPerRow: 2,
          fieldVariant: 'filled',
          groups: [
            {
              columns: [
                {
                  type: 'text',
                  field: 'username',
                  label: 'Employee Username',
                  mandatory: true,
                  allowWhiteSpaces: false,
                },
                {
                  type: 'text',
                  field: 'firstName',
                  label: 'First name',
                  mandatory: true,
                  allowWhiteSpaces: true,
                },
                {
                  type: 'text',
                  field: 'lastName',
                  label: 'last name',
                  mandatory: true,
                  allowWhiteSpaces: true,
                },
                {
                  type: 'text',
                  field: 'email',
                  label: 'Employee Email',
                  placeholder: 'Enter Employee Email',
                  mandatory: true,
                  allowWhiteSpaces: true,
                },
                autoSuggestOptionsInput({
                  label: 'Status',
                  field: 'status',
                  suggestionField: 'label',
                  valueField: 'label',
                  options: selectStatus,
                  keyField: 'label',
                }),
                autoSuggestOptionsInput({
                  label: 'Role',
                  field: 'role.name',
                  suggestionField: 'label',
                  valueField: 'label',
                  options: selectEmployeeStatus,
                  keyField: 'label',
                }),
              ],
            },
          ],
        },
        {
          columnsPerRow: 2,
          groups: [
            {
              columns: [
  
                <UserCheckBox props={props} />
                ,
                <UserWeekReport props={props}/>
                ,
                <UserModalWeeklyReport  props={props}/>
                ,
                <CustomerInterestNoti  props={props}/>
                ,

                (getUserRole() === 'superadmin' || getUserRole() === 'superdealer') && (
                    <>
                      <hr />
                      <p style={{ fontSize: '1.8rem', marginBottom: '20px' }}>If you want to delete the Employee, click the button below.</p>

                      <button
                        style={{
                          border: 0,
                          width: "120px",
                          padding: "10px 0 10px 0",
                          margin: "20px 0 20px 0px",
                          borderRadius: "10px",
                        }}
                        className='btn btn-danger'
                        data-toggle="modal"
                        data-target="#basicModal"
                      // onClick={deleteDealer}                     
                      >
                        Delete Employee
                      </button>
                    </>
                  ),
              ],
            },
          ],
        },
      ],
    }}
    {...props}
  />
  </>
);

export default EditAppraiseEmployee;
